import {
  Component,
  OnInit,
  ChangeDetectorRef,
  AfterViewChecked,
} from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewChecked {
  toggled: any;
  currentUrl: string = '';
  constructor(private router: Router, private cdr: ChangeDetectorRef) {
    this.currentUrl = this.router.url;
  }

  ngOnInit(): void {}

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }
}
